import { render, staticRenderFns } from "./Changepassword.vue?vue&type=template&id=f3cdd3aa&"
import script from "./Changepassword.vue?vue&type=script&lang=js&"
export * from "./Changepassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports